
import pubsub from '@viewlift/pubsub';
import { fetchPageData } from './fetchPageData';
import jwtDecode from "jwt-decode";
import Cookies from 'js-cookie';
import axios from "axios";
import map from 'lodash/map';
import { fetchGameInsightData } from './fetchGameInsightData';
import { fetchMultiviewTrayData } from './fetchMultiviewTrayData';
import { fetchScheduleGameData } from "./fetchScheduleGamedata";
import { fetchSearchData } from './fetchSearchData';
import { ANALYTICS, FB_EVENTS, pixel_Events } from './helpers/analyticsMap';
import { fetchCategoryData } from './fetchCategoryData';
import { logout } from './MFEs/web-authentication-sdk/src/logic/login/logOut';
import { fetchFeaturedTrayData } from "./helpers/manageSSE";
import trackEvent from './helpers/trackAnalytics';
import { isMobile } from 'react-device-detect';
import { connectSSE } from './SSE';
import { subResourceIntegrity } from "./Graphql/hash"
import { fetchUserObject } from './MFEs/Monetization-Sdk/src/fetchStore';
import { parseJSON } from './MFEs/Monetization-Sdk/src/helper';
import { fetchReplaysData } from './fetchReplaysData';
import logger from './logger';
import { callRequest } from './Graphql/request';
import { logoutUser } from './clevertap';
import getSymbolFromCurrency from 'currency-symbol-map';
import { config as serverConfig } from "../server/config";
import { getStorageItem, clearStorageItem, setStorageItem } from './helpers/storageManager';
import { getTveProviderList } from './components/AdobeRestV2/V2TveLogin/tveListGraphql';
import { getDeviceType, pushAdobeAnalyticsData } from './AdobeAnalytics/AdobeExtention';

const login = import('../client/MFEs/web-authentication-sdk/src/logic/login/login')
const us = import('./MFEs/web-authentication-sdk/src/updateStore');
const contentPages = ["ShowTemplatePage", "VideoTemplatePage", "GameTemplatePage"]

var isTokenRefreshed = false

export function isValidJson(data) {
  try {
    JSON.parse(data);
    return true;
  } catch (e) {
    return false;
  }
}

export const isContentPage = (searchTerm) => {
  if (searchTerm) return true
  const isContentPage = contentPages.includes(window?.page_data?.page?.pageType)
  return isContentPage
}

export const VideoPlayerLocalisationData = () => {
  return {
    relatedVideoTitle: window?.app_data?.appcmsMain?.genericMessages?.relatedVideoTitle || "Recommended",
    settingsTitle: window?.app_data?.appcmsMain?.genericMessages?.settingSectionTitle || "Setting",
    videoQualityText: window?.app_data?.appcmsMain?.genericMessages?.videoQualitySectionTitle || "Video Quality",
    audioLanguageText: window?.app_data?.appcmsMain?.genericMessages?.audioLanguage || "Audio",
    slowMoText: window?.app_data?.appcmsMain?.genericMessages?.slowMoCtaText || "Slow mo",
    enhancedBitrateLabel: window?.app_data?.appcmsMain?.genericMessages?.enhancedBitrateLabel || "Enhanced Bitrate",
  }
};

export const fetchAndSetupPlanGroups = () => {
  axios({
    method: 'GET',
    url: `${window?.app_data?.appcmsMain?.apiConfig?.apiBaseCachedUrl}/v3/monetization/plangroups`,
    params: { site: window?.app_data?.site?.siteInternalName }
  })
    .then((res) => {
      let planGroups = res?.data
      let planGroupList = {};
      if (Array.isArray(planGroups)) {
        planGroups.forEach((planGroup) => {
          planGroupList[planGroup?.id] = planGroup?.planIds
        })
      } else {
        // Defensive: log or handle the unexpected shape
        console.warn('planGroups is not an array:', planGroups);
      }
      localStorage.setItem("planGroupList", JSON.stringify(planGroupList))
    }).catch((err) => {
      console.log(err)
    })
}
export const formulateEntitlementEndPoint = () => {
  let apiConfig = window?.app_data?.appcmsMain?.apiConfig
  let baseUrl = apiConfig?.apiBaseUrl + "/entitlement"
  let overrideEntitlementBaseUrl = apiConfig?.entitlementBaseUrl
  return { overrideEntitlementBaseUrl: overrideEntitlementBaseUrl ? overrideEntitlementBaseUrl : baseUrl, apiBaseUrl: apiConfig?.apiBaseUrl }
}

export const getPreferredLanguage = () => {
  try {
    const preferredLanguage = Cookies.get("preferredLanguage");
    if (!preferredLanguage) return window?.app_data?.appcmsMain?.languages?.default?.code ?? "en";
    return preferredLanguage;
  } catch (e) {
    return window?.app_data?.appcmsMain?.languages?.default?.code ?? "en";
  }
};
export const checkForHBA = async () => {
  let onBoardingPages = window?.app_data?.appcmsPlatform.navigation.onBoarding;
  let isLocateAvailable = false;
  let userHasHBA = false
  onBoardingPages.forEach((page) => {
    if (page.title == "Locate") isLocateAvailable = true;
  })

  let userInfo = getStorageItem("AuthenticationStore")
  if (userInfo?.user?.hbaMetadata?.enabled) {
    userHasHBA = true
  }

  if (isLocateAvailable) {
    if (userHasHBA) return true
    return false
  }

  return true

}

export const pageClientQueryData = async (pageData, setPageData, abConfigData, searchTerm) => {
  window.countryCode = pageData?.countryCode
  const authData = getStorageItem('AuthenticationStore')
  const _t = Cookies.get("userStateToken") || authData?.user?.userState
  const userStateToken = isValidJson(_t) ? JSON.parse(_t) : _t
  let baseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl
  const enableZipCode = window?.app_data?.appcmsMain?.geoRestrict?.zipcodeEnabledForContent || false;
  const disableLocationPermissionOnPage = window?.app_data?.appcmsMain?.geoRestrict?.disableLocationPermissionOnPage
   const deviceType = await getDeviceType()
   if(deviceType) {
    sessionStorage.setItem("deviceType",deviceType)
   }
  let endpoint = window?.cachedAPI || `${baseUrl}/graphql`
  let parsedCountryCode = pageData?.countryCode || "IN"
  let offset = 0
  let variables = {
    site: (window?.app_data?.site?.siteInternalName) || null,
    device: "WEB",
    includeContent: true,
    moduleLimit: 4,
    moduleOffset: offset,
    languageCode: getPreferredLanguage(),
    countryCode: parsedCountryCode,
    userState: authData && userStateToken ? userStateToken : window.btoa(JSON.stringify({ "state": ["loggedOut"] })),
    modules: [],
    platform: 'web_browser'
  }
  let zipCode = sessionStorage.getItem("zipCode")
  let locationData = JSON.parse(localStorage.getItem("locationCoords") || '{}');
  if (locationData?.byCoordinates && locationData?.postalCode) {
    zipCode = locationData?.postalCode || '';
  }
  // only call requestZipcode when enable zipcode is true 
  if (enableZipCode && !disableLocationPermissionOnPage) {
    zipCode = zipCode ? zipCode : await requestZipCode()
  }
  if (zipCode) {
    sessionStorage.setItem("zipCode", zipCode)
    variables["zipcode"] = zipCode
  }
  if (abConfigData?.status) variables["pageId"] = abConfigData?.pageId
  else variables["path"] = location?.pathname
  fetchPageData(variables, endpoint).then((data) => {
    if (data) {
      let page_data = { page: data.data.data["page"], path: location?.pathname };
      setPageData(page_data);
      if (typeof (window) !== undefined) {
        window.page_data = page_data;
      }
      fetchFeaturedTrayData(page_data)
      setPageTree()
      if (!isContentPage(searchTerm)) {
        pushAdobeAnalyticsData({ eventName: "Page Load", config: { type: "page load" } })
      }
      pubsub.publish('apploading', false);
      Cookies.set('apploading', false)
    }
    let abConfigPayload = abConfigData
    handlePageViewEvent(page_data, abConfigPayload)
  }).catch((e) => {
    pubsub.publish('apploading', false);
    Cookies.set('apploading', false)
  });
};
export const handlePageViewEvent = (pageData, abConfigPayload) => {
  var lastActivity = null
  if (document.referrer && document.referrer !== window.location.href) {
    lastActivity = document.referrer
  }
  let gaPageViewPayload = {
    page_title: (pageData.page && pageData.page.metadataMap && pageData.page.metadataMap.title) || "N/A",
    pageId: pageData?.page?.id,
    platform: 'Web'
  }
  let pageViewData = {
    pageName: pageData?.page?.title,
    pageURL: window?.location?.href,
    lastActivityName: lastActivity,
    source: lastActivity,
    platform: 'Web'
  }
  if (abConfigPayload?.status) {
    gaPageViewPayload.pageId = abConfigPayload?.pageId,
      gaPageViewPayload.variationId = abConfigPayload?.variationId
    gaPageViewPayload.hash = abConfigPayload?.hashId
    pageViewData.variationId = abConfigPayload?.variationId
    pageViewData.hash = abConfigPayload?.hashId
    pageViewData.pageId = abConfigPayload?.pageId
  }

  trackEvent('page_view', gaPageViewPayload, null)
  pubsub.publish("FB-analytics", { eventType: FB_EVENTS.PAGE_VIEW, payload: pageViewData, type: 'FB' })
  pubsub.publish("FB-analytics", { eventType: pixel_Events.PAGE_VIEW, payload: pageViewData, type: 'PIXEL' })
}

export const fetchUserData = async (userId, token, skipSubscription = '') => {
  let site =  window?.app_data?.site?.siteInternalName
  let variables = {
    site
  }
  let cb = () => {}
  return callRequest({type : "userIdentity", variables,cb}).then((res) => {
        const store = getStorageItem('AuthenticationStore');
        let storeData = {...store?.user, ...res?.identityUserProfile} 
        let hbaMetadata = store?.user?.hbaMetadata;
        storeData.hbaMetadata=hbaMetadata
        setStorageItem('AuthenticationStore',{user: storeData});
        if(!skipSubscription){
          subscriptionData();
        } 
      // setting userState in cookies for personalized hompage modules rendered from servers side
      Cookies.set("userStateToken", JSON.stringify(res?.identityUserProfile?.userState))
      return res?.identityUserProfile;
    }).catch((err) => {
      let code = err?.response?.data?.code || JSON.parse(err?.message || '');
      let isLoggedOut = code === "UNAUTHORIZED" || code === "DEVICE_NOT_FOUND" || code === "REFRESH_TOKEN_NOT_FOUND" || code === "USER_NOT_FOUND" || code === 'UNKNOWN';
      if (isLoggedOut) fireLogout()
        return
    })
};
export function getQueryParams(qs) {
  let isAppAccessing;
  let paramString = qs?.split('?').length > 0 ? qs?.split('?')[1] : null;
  if (paramString) {
    let params_arr = paramString.split('&') || [paramString];

    for (let i = 0; i < params_arr.length; i++) {
      let pair = params_arr[i]?.split('=');
      if (pair.includes('app')) isAppAccessing = true;
      else isAppAccessing = false;
    }
  }
  return isAppAccessing;
}

export function isAlternateBilling(qs) {
  let isAlternateBilling = '';
  let paramString = qs?.split('?').length > 0 ? qs?.split('?')[1] : null;
  const alternateBillingParams = getAlternateBillingParams()
  if (paramString?.includes('auth') && paramString?.includes('platform') && paramString?.includes('planId') && paramString?.includes('redirectUrl')) {
    isAlternateBilling = true;
  } else if (alternateBillingParams?.externalPlatform && alternateBillingParams?.externalRedirectUrl) {
    isAlternateBilling = true;
  } else {
    isAlternateBilling = false;
  }
  return isAlternateBilling;
}

export function listenToChannel(bc) {
  bc.onmessage = (event) => {
    logger(event, "info");
    let isItHeartbeat = event.heartbeat
    let currentTime = new Date().getTime().toString();
    sessionStorage.setItem('broadcast-heartbeat', currentTime)
    if (!isItHeartbeat) connectSSE(event)
  };
}

export const handleAppLogin = async () => {
  let isAppAccessing = getQueryParams(window.location.href);
  if (isAppAccessing) {
    let userToken = Cookies.get('app-token');
    let userId = jwtDecode(userToken).userId;
    if (userToken) {
      let response = await fetchUserData(userId, userToken);
      setStorageItem('AuthenticationStore', { user: response?.data });
    }
  }
};


let tokenData;
function decodeToken(token) {
  var authToken = jwtDecode(token);
  var tokenExp = authToken.exp;
  var date = new Date(tokenExp * 1000);
  Cookies.set('anonymousUserId', authToken.userId)
  return date;
}

export function setToken(res) {
  var tokenExpiryTime = decodeToken(res.authorizationToken);
  tokenData = {
    expiration: tokenExpiryTime.getTime(),
    authorizationToken: res.authorizationToken,
    refreshToken: res.refreshToken,
    duration: tokenExpiryTime.getTime() - new Date().getTime(),
  };
  Cookies.set('token', JSON.stringify(tokenData), { expires: 365 });
  return tokenData;
}

export const clearToken = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
}

const generateId = _ => {
  const s4 = _ => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

export const getDeviceId = () => {

  if (localStorage.getItem("deviceId")) return localStorage.getItem("deviceId")
  else {
    var deviceId = 'browser-' + generateId();
    localStorage.setItem("deviceId", deviceId)
    return deviceId
  }

}

export const getRefreshToken = () => {
  let token = Cookies.get('token') && JSON.parse(Cookies.get('token'))
  return token?.refreshToken || null;
}

// A temporary holder for the ongoing anonymous or refresh token request promise. Used to avoid multiple parallel token fetches.
let inProgressTokenPromise = null;


/**
 * Ensures getToken always returns a Promise, fixing .then on undefined errors.
 */
export async function getToken(cb) {
  let appToken = Cookies.get("app-token")
  if (appToken) {
    let appAuthorizationToken = parseJSON(appToken)
    if (appAuthorizationToken?.authorizationToken) {
      if (cb) cb(appAuthorizationToken.authorizationToken)
      return Promise.resolve(appAuthorizationToken.authorizationToken)
    } else {
      if (cb) cb(appToken)
      return Promise.resolve(appToken)
    }
  }
  const AuthenticationStore = getStorageItem('AuthenticationStore')
  let user = AuthenticationStore?.user
  let userData = user ? user : {}
  let token = Cookies.get('token') && JSON.parse(Cookies.get('token'))

  // Always return a Promise from this function
  return new Promise((resolve, reject) => {
    // If another fetchToken is in progress, poll until it's done
    if (window.fetchToken) {
      setTimeout(() => {
        // Always return the recursive call so .then is never called on undefined
        getToken(cb).then(resolve).catch(reject)
      }, 500)
      return;
    }

    // If we have a valid token, resolve immediately
    if (token?.authorizationToken || user?.authorizationToken) {
      let currentToken = token?.authorizationToken || user?.authorizationToken
      var tokenExpiryTime = decodeToken(currentToken)
      var now = new Date().getTime();
      if (now < tokenExpiryTime) {
        if (cb) cb(currentToken)
        resolve(currentToken)
        window.fetchToken = false
        return
      }
    }

    // If an anonymous token or refresh token request is already in progress, return the existing promise instead of initiating a new request.
    // if(inProgressTokenPromise) return inProgressTokenPromise

    if ((token?.refreshToken || tokenData?.refreshToken || (userData && Object.keys(userData).length > 0) && !window.fetchingRefreshToken) && !isTokenRefreshed) {
      logger(`called from client helper refresh inside: ${isTokenRefreshed}`, "info")
      isTokenRefreshed = true
      window.fetchingRefreshToken = true
      inProgressTokenPromise = axios({
        method: 'GET',
        url: `${window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl}/identity/refresh/${token?.refreshToken || userData?.refreshToken}`,
      }).then(res => {
        var d = res.data && {
          authorizationToken: res.data.authorizationToken,
          refreshToken: res.data.refreshToken
        }
        setToken(d)
        inProgressTokenPromise = null;
        setStorageItem('AuthenticationStore', { user: { ...user, ...d } })
        if (cb) cb(d?.authorizationToken, d?.refreshToken)
        window.fetchToken = false
        window.fetchingRefreshToken = false
        isTokenRefreshed = false
        resolve(d.authorizationToken, d?.refreshToken)
      }).catch(err => {
        inProgressTokenPromise = null;
        window.fetchToken = false
        logger(`Error refreshing token: ${err}`, "error")
        window.fetchingRefreshToken = false
        isTokenRefreshed = false
        clearStorageItem();
        sessionStorage.removeItem("token")
        clearToken('token')
        if (err?.response?.data?.code === "REFRESH_TOKEN_NOT_FOUND") {
          setTimeout(() => {
            window.location.assign("/");
          }, 2000);
        } else {
          window.location.assign("/");
        }
        reject(err)
      })
      return
    }

    // If user, remove user
    var url = `${window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl}/identity/anonymous-token`

    // Fetch token
    if (!window.fetchToken && (!(token?.refreshToken) && !(tokenData?.refreshToken))) {
      var deviceId = getDeviceId();
      inProgressTokenPromise = axios({
        method: "GET",
        url: url,
        params: {
          site: window?.app_data?.site?.siteInternalName,
          platform: "web_browser",
          deviceId: deviceId
        },
        headers: {
          "x-api-key": window?.xApiKey
        }
      })
        .then(res => {
          var d = res.data && { authorizationToken: res.data.authorizationToken };
          const decodeUserId = jwtDecode(res.data.authorizationToken)?.userId
          sessionStorage.setItem('anoynomousToken', decodeUserId)
          setToken(d);
          inProgressTokenPromise = null;
          window.fetchToken = false
          if (cb) cb(d.authorizationToken, d.refreshToken);
          resolve(d.authorizationToken, d.refreshToken);
        })
        .catch(err => {
          inProgressTokenPromise = null;
          window.fetchToken = false
          logger(`Error fetching anonymous token:${err}`, "error")
          pubsub.publish('isLoading', false)
          reject(err);
        });
      return
    }

    // If none of the above, reject to avoid hanging
    reject(new Error("Unable to obtain token"))
  })
}

export const updateSseStore = (data) => {
  let store = JSON.parse(localStorage.getItem('SseStore'))
  let sseStore;
  if (store) {
    if (store[Object.keys(data)[0]]) {
      let prevData = store[Object.keys(data)[0]];
      let newData = {
        ...prevData,
        ...Object.values(data)[0]
      };
      store[Object.keys(data)[0]] = newData;
      sseStore = { ...store };
    } else {
      sseStore = { ...store, ...data };
    }
  } else {
    sseStore = { ...data };
  }
  localStorage.setItem('SseStore', JSON.stringify(sseStore));
  window[Object.keys(data)[0]] = {
    ...window[Object.keys(data)[0]],
    ...Object.values(data)[0]
  }
  pubsub.publish(Object.keys(data)[0], Object.values(data)[0]);
  checkForGameCardUpdates(Object.keys(data)[0], Object.values(data)[0])
};


const checkForGameCardUpdates = (gameId, gameData) => {

  let gameCardsReference = document.querySelectorAll(`.game-card-${gameId}`);
  gameCardsReference.forEach((item) => {
    let homeScoreElement = item.querySelector('.gameCard-homeScore') || "0";
    if (homeScoreElement) {
      homeScoreElement.textContent = gameData.homePoint;
    }
    let awayScoreElement = item.querySelector('.gameCard-awayScore') || "0";
    if (awayScoreElement) {
      awayScoreElement.textContent = gameData.awayPoint;
    }
  });
}

export const updateLeaderboardSse = (data) => {
  let store = JSON.parse(localStorage.getItem('leaderboardSseStore'))
  let leaderboardSseStore
  if (store) {
    leaderboardSseStore = { ...store, ...data }
  } else {
    leaderboardSseStore = { ...data }
  }
  localStorage.setItem('leaderboardSseStore', JSON.stringify(leaderboardSseStore));
  pubsub.publish(Object.keys(data)[0], Object.values(data)[0])
}

export const updateGraphicsData = (data) => {
  let store = JSON.parse(localStorage.getItem('playerGraphicsStore'))

  let playerGraphicsStore
  if (store) {
    playerGraphicsStore = { ...store, ...data }
  } else {
    playerGraphicsStore = { ...data }
  }
  localStorage.setItem('playerGraphicsStore', JSON.stringify(playerGraphicsStore));
}



export const updatePlayerNextStrokeSSE = (data) => {
  let store = JSON.parse(localStorage.getItem('playerNextStrokeSSEStore'))
  let playerNextStrokeSSEStore
  if (store) {
    playerNextStrokeSSEStore = { ...store, ...data }
  } else {
    playerNextStrokeSSEStore = { ...data }
  }
  localStorage.setItem('playerNextStrokeSSEStore', JSON.stringify(playerNextStrokeSSEStore));
  pubsub.publish('STREAM_SWITCH', Object.values(data)[0])
}

export const getTeamTitles = (teams) => {
  let teamsTitles = {};
  let homeTeamShortName = teams?.homeTeam?.shortName;
  let awayTeamShortName = teams?.awayTeam?.shortName;
  if (homeTeamShortName) teamsTitles.homeTeamTitle = homeTeamShortName;
  else {
    let title = teams?.homeTeam?.gist?.title.split(" ");
    teamsTitles.homeTeamTitle = title && title[0];
  }
  if (awayTeamShortName) teamsTitles.awayTeamTitle = awayTeamShortName;
  else {
    let title = teams?.awayTeam?.gist?.title.split(" ");
    teamsTitles.awayTeamTitle = title && title[0];
  }
  return teamsTitles;
};

export const gameInsightQueryData = async (league, srGameId) => {
  const apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
  let endpoint = `${apiBaseUrl}/graphql`;
  let variables = {
    site: window?.app_data?.site?.siteInternalName,
    league: league,
    srGameId: srGameId,
    srPlayerId: null,
    srTeamId: null,
    offset: null
  };
  return fetchGameInsightData(variables, endpoint);
};

export const multiviewTrayQueryData = async (gameId, ids = [], limit = 10, offset = 0) => {
  const apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
  let endpoint = `${apiBaseUrl}/graphql`;
  let variables = {
    site: window?.app_data?.site?.siteInternalName,
    ids: ids,
    contentType: "COLLECTION",
    gameId: gameId,
    countryCode: window?.app_data?.countryCode,
    languageCode: window?.app_data?.appcmsMain?.languages?.default?.code || "en",
    limit: limit,
    offset: offset
  };
  return fetchMultiviewTrayData(variables, endpoint);
};

export const categoryQueryData = async (path, contentType, nextValue, modules, offset) => {
  const apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
  let endpoint = `${apiBaseUrl}/graphql`;
  let variables = {
    site: window?.app_data?.site?.siteInternalName,
    path: path,
    device: 'WEB',
    includeContent: true,
    languageCode: getPreferredLanguage(),
    countryCode: window?.page_data?.countryCode || window?.app_data?.countryCode,
    contentType: contentType,
    next: nextValue,
    modules: modules
  };
  return fetchCategoryData(variables, endpoint);
};

export const replayQueryData = async (path, contentType, nextValue, modules) => {
  const apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
  let endpoint = `${apiBaseUrl}/graphql`;
  let variables = {
    site: window?.app_data?.site?.siteInternalName,
    path: path,
    device: 'WEB',
    includeContent: true,
    languageCode: window?.app_data?.appcmsMain?.languages?.default?.code || "en",
    countryCode: window?.page_data?.countryCode,
    contentType: contentType,
    next: nextValue,
    modules: modules
  };
  return fetchReplaysData(variables, endpoint);
};

export const scheduleGameQueryData = async (startDate, endDate, teams = [],source, teamIds,league) => {
  const apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
  let baseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl
  let endpoint = window?.cachedAPI || `${baseUrl}/graphql`
  let variables = {
    site: window?.app_data?.site?.siteInternalName,
    limit: 50,
    offset: 0,
    startDate: startDate,
    endDate: endDate,
    sortBy: null,
    sortOrder: null,
    countryCode: window?.app_data?.countryCode,
    source:source,
    teamIds: teams.length > 0 ? teams : Array.isArray(teamIds) ? teamIds : undefined,
    leagueIds: league,
  };
  return fetchScheduleGameData(variables, endpoint);
};

export const addLikeContentById = async (payload) => {
  const apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
  let endpoint = `${apiBaseUrl}/v2/user/like`;
  const token = await getToken();
  let headers = {
    headers: { 'Authorization': token }
  };
  return axios.post(endpoint, payload, headers);
};

export const removeLikeContentById = async (contentId, contentType, originalObjectId = null) => {
  const apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
  let endpoint = `${apiBaseUrl}/v2/user/like?contentId=${contentId}&contentType=${contentType}`;
  const token = await getToken();
  let headers = {
    headers: { 'Authorization': token }
  };
  const payload = { "originalObjectId": originalObjectId }
  if (originalObjectId) return axios.delete(endpoint, payload, headers)
  return axios.delete(endpoint, headers);
};

export const addWatchListContentById = async (payload) => {
  const apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
  const profile = getStorageItem('AuthenticationStore')
  const profileId = profile?.user?.profiles?.[0]?.profileId
  let endpoint = `${apiBaseUrl}/v2/user/queues?profileId=${profileId}`;
  const token = await getToken();
  let headers = {
    headers: { 'Authorization': token }
  };
  return axios.post(endpoint, payload, headers);
};

export const removeWatchListContentById = async (contentId, contentType, originalObjectId = null) => {
  const apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
  const profile = getStorageItem('AuthenticationStore')
  const profileId = profile?.user?.profiles?.[0]?.profileId
  let endpoint = `${apiBaseUrl}/v2/user/queues?contentId=${contentId}&contentType=${contentType}&profileId=${profileId}`;
  const token = await getToken();
  let headers = {
    headers: { 'Authorization': token }
  };
  const payload = { "originalObjectId": originalObjectId }
  if (originalObjectId) return axios.delete(endpoint, payload, headers);
  return axios.delete(endpoint, headers);
};

const watchListAnalytics = (watchlistData) => {
  let arr = watchlistData.map((ele) => {
    return ele.content.id;
  })
  pubsub.publish('user-analytics', { ename: ANALYTICS.REMOVE_ALL_WATCHLIST, data: { items: arr } })
}

const watchHistoryAnalytics = (watchHistoryData) => {
  let arr = watchHistoryData?.map((ele) => {
    return ele.content.id;
  })
  pubsub.publish('user-analytics', { ename: ANALYTICS.REMOVE_ALL_WATCHHISTORY, data: { items: arr } });
}

export const removeAllWatchList = async (data) => {
  const apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
  const hideWatchlist = window?.app_data?.appcmsMain?.features?.hideWatchlist || false;
  const profile = getStorageItem('AuthenticationStore')
  const profileId = profile?.user?.profiles?.[0]?.profileId
  if (hideWatchlist) {
    localStorage.removeItem(`watchlist-data-${profileId}`);
    return Promise.resolve(); // ensure Promise is always returned
  } else {
    let endpoint = `${apiBaseUrl}/v2/user/queues?contentId=ALL&profileId=${profileId}`;
    const token = await getToken();
    let headers = {
      headers: { 'Authorization': token }
    };
    return axios.delete(endpoint, headers).then((res) => {
      watchListAnalytics(data);
    });
  }
};

const getWatchHistoryFromStorage = (profileId) => {
  let watchHistoryData = [];
  const site = window?.app_data?.site?.siteInternalName || ''
  const dataKey = profileId ? `watchhistory-data-${profileId}` : `watchhistory-data-guest-${site}`;
  if (dataKey) {
    watchHistoryData = JSON.parse(localStorage.getItem(`${dataKey}`) || '[]');
  }
  return watchHistoryData;
}

export const getUserWatchHistory = async (offset) => {
  const isWatchHistoryEnable = window?.app_data?.appcmsMain?.features?.watched_history?.enable || false;
  if (isWatchHistoryEnable) {
    let historyOffset = offset || 0
    const apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
    let endpoint = `${apiBaseUrl}/v2/user/history?limit=8&offset=${historyOffset}`;
    const token = await getToken();
    let headers = {
      headers: { 'Authorization': token }
    };
    return axios.get(endpoint, headers);
  } else {
    const user = await fetchUserDetails();
    const watchHistoryData = getWatchHistoryFromStorage(user?.profileId || '');
    const data = {
      count: watchHistoryData?.length,
      limit: watchHistoryData?.length,
      offset: 0,
      records: watchHistoryData
    };
    return { data };
  }
};

export const removeUserWatchHistoryById = async (videoId, data) => {
  const isWatchHistoryEnable = window?.app_data?.appcmsMain?.features?.watched_history?.enable || false;
  if (isWatchHistoryEnable) {
    const apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
    let endpoint = `${apiBaseUrl}/v2/user/history?videoId=${videoId}`;
    const token = await getToken();
    let headers = {
      headers: { 'Authorization': token }
    };
    return axios.delete(endpoint, headers).then((res) => {
      watchHistoryAnalytics(data);
    });
  } else {
    const site = window?.app_data?.site?.siteInternalName || ''
    const user = await fetchUserDetails();
    const profileId = user?.profileId || '';
    const dataKey = profileId ? `watchhistory-data-${profileId}` : `watchhistory-data-guest-${site}`;
    if (videoId === 'ALL') {
      localStorage.removeItem(`${dataKey}`);
    } else {
      const watchHistoryData = getWatchHistoryFromStorage(profileId);

      const filterData = watchHistoryData?.filter(data => data?.content?.id !== videoId);
      localStorage.setItem(`${dataKey}`, JSON.stringify(filterData));
    }
    return Promise.resolve(); // Always return a Promise
  }
};

export const getWatchListFromStorage = (profileId) => {
  let watchListData = [];
  if (profileId) {
    watchListData = JSON.parse(localStorage.getItem(`watchlist-data-${profileId}`) || '[]');
  }
  return watchListData;
}

export const getUserWatchList = async () => {
  const apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
  const hideWatchlist = window?.app_data?.appcmsMain?.features?.hideWatchlist || false;
  const profile = getStorageItem('AuthenticationStore')
  const profileId = profile?.user?.profiles?.[0]?.profileId
  if (hideWatchlist) {
    const watchListData = getWatchListFromStorage(profileId);
    const data = {
      records: watchListData
    };
    return { data };
  } else {
    let endpoint = `${apiBaseUrl}/v2/user/queues?profileId=${profileId}`;
    const token = await getToken();
    let headers = {
      headers: { 'Authorization': token }
    };
    return axios.get(endpoint, headers);
  }
};

export const removeUserWatchlistById = async (contentId, contentType) => {
  const apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
  const hideWatchlist = window?.app_data?.appcmsMain?.features?.hideWatchlist || false;
  const profile = getStorageItem('AuthenticationStore')
  const profileId = profile?.user?.profiles?.[0]?.profileId
  if (hideWatchlist) {
    let dataKey = `watchlist-data-${profileId}`;
    const prev = JSON.parse(localStorage.getItem(dataKey) || '[]');
    const updated = prev.filter(item => !(item?.content?.id === contentId && item?.content?.type === contentType));
    localStorage.setItem(dataKey, JSON.stringify(updated));
    return Promise.resolve(); // Always return a Promise
  } else {
    let endpoint = `${apiBaseUrl}/v2/user/queues?contentId=${contentId}&contentType=${contentType}&profileId=${profileId}`;
    const token = await getToken();
    let headers = {
      headers: { 'Authorization': token }
    };
    return axios.delete(endpoint, headers);
  }
};

export const getUserConetntInfo = async (contentType, contentId) => {
  const apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
  const profile = getStorageItem('AuthenticationStore')
  const profileId = profile?.user?.profiles?.length && profile?.user?.profiles?.[0]?.profileId
  let endpoint = `${apiBaseUrl}/v2/user/info/${contentType}/${contentId}?profileId=${profileId}`;
  const token = await getToken();
  let headers = {
    headers: { 'Authorization': token }
  };
  return axios.get(endpoint, headers);
};
/**
 * 
 * @param {import('./types/StandaloneSearchTypes').SearchParamsType} params?
 * @returns 
 */
export const searchResultData = async (params) => {
  const apiConfig = window?.app_data?.appcmsMain?.apiConfig;
  const apiBaseUrl = apiConfig?.contentBaseCachedUrl || apiConfig?.contentBaseUrl;
  let endpoint = `${apiBaseUrl}/search`;
  let variables = {
    languageCode: getPreferredLanguage(),
    countryCode: window?.app_data?.countryCode || 'IN',
    searchTerm: params.key,
    site: window?.app_data?.site?.siteInternalName || null,
    userState: '',
    limit: 100,
    offset: 0,
    relatedSearch: true,
    types: params.type.toString(),
  };
  return fetchSearchData(variables, endpoint, { xApiKey: window?.xApiKey });
};

export const switchBetweenPages = () => {
  pubsub.publish('apploading', true);
  handleNewTabLoader()
  return true
};

export const handleNewTabLoader = () => {
  Cookies.set('apploading', true)
  setTimeout(() => {
    let appLoading = Cookies.get('apploading')
    if (appLoading) {
      Cookies.set('apploading', false)
      pubsub.publish('apploading', false);
    }
  }, 3000)
}
export const handleImageImpolicy = (src, imWidth, imHeight) => {
  if (src.includes("impolicy")) {
    let srcSplit = src.split("impolicy")
    let newSrc = `${srcSplit[0]}impolicy=resize&w=${imWidth}&h=${imHeight}`
    // newSrc[1] = `impolicy=resize&w=${imWidth}&h=${imHeight}`
    // newSrc.join(``)
    return newSrc
  } else {
    return `${src}?impolicy=resize&w=${imWidth}&h=${imHeight}`
  }
}

export const getAppDataConfig = () => {
  const appData = window?.app_data?.appcmsMain?.firebaseConfig
  return appData
}

export const listenDisposeCookies = () => {
  pubsub.subscribe('dispose-cookies', (cookie) => {
    Cookies.remove(cookie);
  })
}

export const handleUserLogInState = async () => {
  let state = {
    isUserLoggedIn: false,
    isUserSubscribed: false,
  };
  const AuthenticationStore = getStorageItem('AuthenticationStore')
  let user = AuthenticationStore?.user
  let istveSubscribed = user?.tveProvider || user?.tveMetadata?.tveProvider
  if (user?.userId) state = { ...state, isUserLoggedIn: true };
  if (user?.isSubscribed || istveSubscribed) state = { ...state, isUserSubscribed: true };
  localStorage.setItem('loginState', JSON.stringify(state))
};
export const fireLogout = () => {
  logoutUser()
  logout().then((res) => {
    clearStorageItem();
    localStorage.removeItem('dismissSplash')
    Cookies.remove('userStateToken');
    localStorage.removeItem('pageRefreshStatus');
    localStorage.removeItem('hidePersonalizationBanner');
    pubsub.publish('dispose-cookies', 'token')
    pubsub.publish('apploading', false)
    window?.AE && window?.AE.logout()
    window?.location.assign("/");
    return res.data;
  })
    .catch((e) => {
      logger(e, "error");
      pubsub.publish('apploading', false)
      return e;
    });
};

export const tveSignOut = async () => {
  let apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl
  let token = await getToken((token) => { return token })
  const options = {
    method: 'POST',
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
      'Authorization': token
    }
  };

  return fetch(`${apiBaseUrl}/identity/tveSignout`, options)
    .then(response => response.json())
}

const handleDeviceRemoved = (data) => {
  let deviceIds = data?.deviceIds
  let currdeviceId = localStorage.getItem('deviceId')
  if (deviceIds.includes(currdeviceId) || deviceIds[0] === "ALL") fireLogout()
}

export const listenDeviceRemoved = () => {
  pubsub.subscribe('DEVICE_REMOVED', handleDeviceRemoved)
}

export const handleSeviceTypes = () => {
  let serviceTypes = {
    SVOD: false,
    TVOD: false,
    TVE: false,
    AVOD: false,
    FREE_LOGIN: false,
    EMAIL_REQUIRED: false
  }
  let services = window?.app_data?.appcmsMain?.serviceTypes || []
  if (services.includes("SVOD")) serviceTypes.SVOD = true
  if (services.includes("TVOD")) serviceTypes.TVOD = true
  if (services.includes("TVE")) serviceTypes.TVE = true
  if (services.includes("AVOD")) serviceTypes.AVOD = true
  return serviceTypes
}

export const checkVppaCompliance = () => {
  let vppaEnabled = window?.app_data?.site?.settings?.compliance?.vppa
  let UserJourney = window?.location?.pathname

  const store = getStorageItem('AuthenticationStore')
  if (store?.user?.userId && vppaEnabled && !store?.user?.vppaCompliance && UserJourney != '/consent' && location) {
    const navigateToExternalUrl = isNavigateToExternalUrl();
    const externalUrl = isExternalUrl();
    if (location.pathname == '/tos' || location.pathname == '/privacy-policy' || location.pathname == '/agreement' || location.pathname == '/offers' || navigateToExternalUrl || externalUrl) {
      return
    }
    location.href = '/consent'
  }
}
function copyScriptsInHtml(htmlNode) {
  const scriptTags = htmlNode.getElementsByTagName("vlscript")

  return map(scriptTags, tag => {
    if (tag) {
      let newTag = document.createElement("script")
      if (tag.hasAttributes()) {
        for (const attr of tag.attributes) {
          newTag.setAttribute(attr.name, attr.value);
        }
      }
      if (tag.attributes?.type) {
        newTag.type = tag.attributes?.type?.value
      }

      tag.textContent && (newTag.textContent = tag.textContent)
      return newTag
    }
  })
}

export const updateVppaStatus = (userID, token, consent) => {

  return axios({
    method: 'PUT',
    url: `${window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl}/v2/identity/${userID}`,
    headers: {
      Authorization: token,
    },
    data: {
      "vppaCompliance": consent
    }
  })
    .then((res) => {
      return res;
    }).catch((err) => {
      let code = err?.response?.data?.code
      fireLogout()
    })
}

export const removeAlldevices = (token) => {
  return axios({
    method: 'DELETE',
    url: `${apiBaseUrl}/user/device/desync`,
    headers: {
      'Authorization': token,
      'x-api-key': window?.xApiKey
    },
    params: {
      site: window?.app_data?.site?.siteInternalName,
    }
  })
}
export const rejectAndLogout = async () => {
  pubsub.publish("apploading", true)

  getToken((token) => {
    removeAlldevices(token)
      .then(() => {
        fireLogout()
      })
      .catch(() => {
        logger("failed to remove devices", "error")
        pubsub.publish('apploading', false)
      })
  })

}

export const embedCode = () => {
  if (typeof window !== undefined) {
    let scripted = window?.app_data?.appcmsMain.features.embeddedCode;
    if (scripted) {
      scripted = scripted.replace(/(\r\n|\n|\r)/gm, "");
      const html = document.createElement("div");
      html.insertAdjacentHTML('beforeend', scripted);
      let gtmscript = copyScriptsInHtml(html);
      gtmscript.forEach((script) => {
        if (script?.innerText) {
          script?.setAttribute("integrity", subResourceIntegrity(script?.innerText));
        }
        document.body.appendChild(script);
      });
    }
  }
};

export const initGTM = () => {
  let gtmId = window?.app_data?.appcmsPlatform?.analytics?.googleTagManagerId || null
  if (!gtmId)
    return
  (function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l !== 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, window.document, 'script', 'dataLayer', gtmId);
}

export const pushToDatalayer = (key, value) => {
  if (window?.dataLayer) {
    let newValue = {}
    newValue[key] = value;
    window?.dataLayer.push(newValue);
  }
}
export const convertToJSON = (str) => {
  const groupArray = str?.split(',');
  const groupObject = {};
  groupArray?.forEach(pair => {
    const [key, value] = pair.split(':');
    groupObject[key] = Number(value);
  });
  return groupObject
}

export const insertCookieBanner = () => {
  let cdnUrl = window?.app_data?.appcmsPlatform?.privacy?.oneTrust?.cdnUrl
  let clientID = window?.app_data?.appcmsPlatform?.privacy?.oneTrust?.clientId
  if (!cdnUrl && !clientID) return
  const script = document.createElement('script');
  script.src = cdnUrl;
  script.type = 'text/javascript';
  script.setAttribute('data-domain-script', clientID);
  document.head.appendChild(script);
  const functionScript = document.createElement('script');
  functionScript.type = 'text/javascript';
  functionScript.text = function OptanonWrapper() { }
  document.head.appendChild(functionScript);
}
export const getTVProviderLogo = (provider) => {
  let providers = window.app_data.appcmsPlatform.tveSettings.providers || [];
  const isTveOnlyEnabled = isTveOnlyLoginEnabled()
  if (isTveOnlyEnabled) {
    const currentMvpdInfo = Cookies.get('currentMvpdInfo')
    if (currentMvpdInfo) {
      const parsedData = JSON.parse(currentMvpdInfo)
      return parsedData?.logoUrl
    } else {
      return getTveProviderList().then((res) => {
        const allProviderList = res.data.bootstrap.appcmsPlatform.tveSettings.providers
        let filteredUrls = allProviderList.filter((ele) => {
          if (ele.identifier == provider) {
            Cookies.set('currentMvpdInfo', JSON.stringify(ele))
            return ele?.logoUrl;
          }
        })
        return filteredUrls[0].logoUrl
      })
    }
  }
  else {
    let currentProvider = providers.filter((ele) => {
      if (ele.identifier == provider)
        return ele?.logoUrl;
    })
    return currentProvider?.[0]?.logoUrl || null;
  }
}

export const handleUserLogout = async (userId) => {
  if (userId) {
    let token = await getToken(token => { return token })
    fetchUserData(userId, token)
  }
}

export const getTVProvider = async () => {
  const store = getStorageItem('AuthenticationStore')
  return store?.user?.tveMetadata?.idpName || null
}

export const getFwTveProvider = async () => {
  const store = getStorageItem('AuthenticationStore')
  let mvpdID = store?.user?.tveMetadata?.idpName || null
  if (!mvpdID) return null
  return extractFreeWheelId(mvpdID);
}

const extractFreeWheelId = (mvpdID) => {
  let providers = window.app_data.appcmsPlatform.tveSettings.providers
  const isTveOnlyEnabled = isTveOnlyLoginEnabled()
  if (isTveOnlyEnabled) {
    const getFwidentifier = localStorage.getItem('selectedMvpdFw')
    return getFwidentifier
  } else {
    let selectedProvider = providers.find((provider) => {
      if (provider.identifier === mvpdID) return true
    })
    return selectedProvider.fwIdentifier || null
  }
}

export const getUserSubscription = async () => {
  const store = getStorageItem('AuthenticationStore');
  let SVOD = (store && store?.user?.isSubscribed && !store?.user?.tveUserId) || false;
  let TVE = (store && !store?.user?.isSubscribed && (store?.user?.tveProvider || store?.user?.tveMetadata?.tveProvider)) || false;
  return {
    SVOD: SVOD,
    TVE: TVE
  }
}
export const getMacrosFromMetaData = async (metadata) => {
  let retObj = {};
  const store = getStorageItem('AuthenticationStore');
  let macroMap = new Map();
  metadata?.length && metadata.map((ele) => {
    macroMap.set(ele.name, ele.value);
  })

  let SVOD = (store && store?.user?.isSubscribed && !store?.user?.tveUserId) || false;
  let TVE = (store && !store?.user?.isSubscribed && (store?.user?.tveProvider || store?.user?.tveMetadata?.tveProvider)) || false;

  // CSID
  if (isMobile) {
    if (SVOD)
      retObj = { ...retObj, VIEWLIFT_CSID: macroMap.get('csid.mweb.dtc') || '' };

    else if (TVE)
      retObj = { ...retObj, VIEWLIFT_CSID: macroMap.get('csid.mweb.tve') || '' };
  }
  else {
    if (SVOD)
      retObj = { ...retObj, VIEWLIFT_CSID: macroMap.get('csid.web.dtc') || '' };

    else if (TVE)
      retObj = { ...retObj, VIEWLIFT_CSID: macroMap.get('csid.web.tve') || '' };
  }

  // SFID
  if (SVOD)
    retObj = { ...retObj, VIEWLIFT_SFID: macroMap.get('sfid.dtc') || '' };

  else if (TVE)
    retObj = { ...retObj, VIEWLIFT_SFID: macroMap.get('sfid.tve') || '' };

  // PROF
  if (isMobile)
    retObj = { ...retObj, VIEWLIFT_PROF: macroMap.get('prof.mweb') || '' };
  else
    retObj = { ...retObj, VIEWLIFT_PROF: macroMap.get('prof.web') || '' };

  return retObj;
}
/**
 * 
 * @param {String} value 
   * @returns {String} sanitized string 
 */
export const sanitizeInputValue = (value) => {
  const pattern = /(function\s*\([^)]*\)|\(\s*[^)]*\)\s*=>)\s*{[^}]*}|<[^>]*>/g
  return value.replace(pattern, "");
}
/**
 * @param {{coppa: boolean, gdpr: boolean, vppa: boolean}} compliance 
 * @returns {string[]} array of flow steps 
 */
export function getFlowSteps(compliance) {
  const onboardingFlow = app_data?.appcmsPlatform?.navigation?.onBoarding || []
  const flowUrls = onboardingFlow.map(item => item.url)
  // add consent step if vppa is enabled and not added in onboarding flow
  if (compliance?.vppa && !flowUrls.includes("/consent")) flowUrls.splice(1, 0, '/consent')
  // remove consent step if vppa is disabled and added in onboarding flow
  if (!compliance?.vppa && flowUrls.includes("/consent")) flowUrls.filter(url => url !== "/consent")
  if(window?.app_data?.monetisationModelByCountry !== "SVOD") {
    if(flowUrls.includes("/viewplans")) flowUrls.splice(flowUrls.indexOf('/viewplans'), 1); 
    if(flowUrls.includes("/subscription")) flowUrls.splice(flowUrls.indexOf('/subscription'), 1);
  }
  return flowUrls
}

export const fetchUserDetails = async () => {
  const AuthenticationStore = getStorageItem('AuthenticationStore')
  if (!AuthenticationStore) return {}
  let user = AuthenticationStore && AuthenticationStore.user
  let token = await getToken(token => { return token })
  let mvpdProvider = user?.tveMetadata?.mvpdProvider || null
  let profileId = AuthenticationStore.user?.profiles?.length && AuthenticationStore.user?.profiles[0]?.profileId
  let hba = AuthenticationStore?.user?.hbaMetadata
  const subscribedPlanId = AuthenticationStore?.user?.subscription?.subscriptionInfo?.planId
  const subscriptionInfo = AuthenticationStore?.user?.subscription?.subscriptionInfo
  const subscriptionPlanInfo = AuthenticationStore?.user?.subscription?.subscriptionPlanInfo
  return { token: token, userId: user?.userId, profileId: profileId, hba, subscribedPlanId, isSubscribed: user?.isSubscribed, user, nickName: user?.nickname, mvpdProvider, isVip: user?.isVip, subscriptionInfo, subscriptionPlanInfo }
}
let subInfoDebounce = false
export const subscriptionData = async () => {
  let token = await getToken(token => { return token })
  let { userId } = await fetchUserDetails()
  if (userId && !subInfoDebounce) {
    subInfoDebounce = setTimeout(() => {
      axios({
        method: 'GET',
        url: `${apiBaseUrl}/v3/subscription/user`,
        params: { site: window?.app_data?.site?.siteInternalName, userId: userId },
        headers: {
          Authorization: token,
          'x-api-key': window?.xApiKey
        }
      }).then((res) => {
        let subscriptionStatus = res?.data?.subscriptionInfo?.subscriptionStatus
        let isSubscribed = ((subscriptionStatus === 'COMPLETED') || (subscriptionStatus === "DEFERRED_CANCELLATION")) ? true : false
        const store = getStorageItem('AuthenticationStore');
        setStorageItem('AuthenticationStore', { user: { ...store?.user, subscription: { ...res.data, subscriptionStatus: res?.data?.subscriptionInfo?.subscriptionStatus }, isSubscribed } })
        pubsub.publish("update-user-state", true)
      }).catch((e) => {
        console.log(e)
      })
      clearTimeout(subInfoDebounce)
    }, 0)
  }
}

export const handleUserTransactions = async () => {
  const store = getStorageItem('AuthenticationStore')
  if (store?.user) {
    const token = await getToken();
    axios({
      method: 'GET',
      url: `${apiBaseUrl}/v3/transaction`,
      headers: {
        Authorization: token,
      },
    }).then(async (res) => {
      let transactionUserList = getStorageItem('transactionUserList');
      let list = [];
      res?.data?.records?.length &&
        res.data.records.map((content) => {
          let contentId = content?.contentId;
          let itemIds = content?.itemIds;
          if (contentId) list.push(contentId);
          if (itemIds?.length) list.push(...itemIds);
        });
      if (transactionUserList?.length) {
        list = [...transactionUserList, ...list];
      }
      setStorageItem('transactionUserList', { transactionUserList: list });
    });
  }
};

export const checkIfOnlyAudio = (metadata) => {
  let isAudio = false;
  for (let i = 0; i < metadata?.length; i++) {
    if (metadata?.[i]?.name == 'audio-only' && metadata?.[i]?.value == 'true') {
      isAudio = true;
      break;
    }
  }
  return isAudio || false;
}

export function handleQueryUrls() {
  // qs window.location.href
  let qs = window.location.href
  let currentPath = window.location.pathname
  // let queryEnabledUrl = {isManageCard : false, isUpgradeSubscription : false}
  let paramString = qs?.split('?').length > 0 ? qs?.split('?')[1] : null
  if (paramString) {
    let params_arr = paramString.split('&') || [paramString];
    for (let i = 0; i < params_arr.length; i++) {
      let pair = params_arr[i]?.split('=');
      const store = getStorageItem('AuthenticationStore')
      let user = store?.user
      if (pair.includes("isTveUser")) {
        return pair[1] === 'Authenticated' ? true : false
      }
      if (!user) {
        if (pair.includes('planId')) {
          sessionStorage.setItem('contentPlanIds', pair[1])
        }
        if (pair.includes('offer')) {
          sessionStorage.setItem('offer', pair[1])
          if (currentPath == '/subscription') {
            let isRedirected = getStorageItem("isRedirected")
            setStorageItem('isRedirected', { ...isRedirected, path: "subscription", redirect: true })
          }
        }
        if (pair.includes('managecard')) {
          localStorage.setItem('updateCardStatus', JSON.stringify(true))
        }
        if (pair.includes('upgradeplan')) {
          let isRedirected = getStorageItem("isRedirected")
          setStorageItem('isRedirected', { ...isRedirected, isUpgradePlan: true, path: "viewplans?upgradeplan=true" })
          pubsub.publish('redirect', "/authentication")
        }
        if (pair.includes('upgradeSubscription') && currentPath === '/') {
          let isRedirected = getStorageItem("isRedirected")
          setStorageItem('isRedirected', { ...isRedirected, path: `/?${paramString}`, redirect: true })
          pubsub.publish('redirect', "/authentication");
        }
      }
      if (user?.isSubscribed) {
        if (pair.includes('managecard')) {
          sessionStorage.setItem('updateCardStatus', JSON.stringify(true))
        }
        if (pair.includes('upgradeplan')) {
          let isRedirected = getStorageItem("isRedirected")
          setStorageItem('isRedirected', { ...isRedirected, isUpgradePlan: true, path: "/" })
        }
      } else {
        if (pair.includes('managecard')) {
          localStorage.setItem('updateCardStatus', JSON.stringify(false))
          pubsub.publish('redirect', "/")
        }
      }
    }
  }
  return false
}

export const handlePermalink = (pageType) => {
  if (typeof window !== "undefined") {
    let permalink = '';
    if (pageType == "content") {
      window?.page_data?.page?.modules?.forEach((module) => {
        if (module.moduleType.includes('DetailModule')) {
          let contentData = module.contentData?.[0];
          let contentType = contentData?.gist?.contentType?.toLowerCase();
          permalink = `${window.toolsUrl}/content/${contentType}/${contentData?.gist?.id}`
        }
      })
    } else {
      permalink = window.templateUrl + '?isRedirectedFromWebApp=true&pageId=' + window?.page_data?.page.id
    }

    return permalink;
  }
  return ''
}

export async function verifyMagicLink() {
  if (typeof window === "undefined") return;
  let queryString = window.location.search;
  let urlParams = new URLSearchParams(queryString);
  const authToken = urlParams.get("auth");
  const userEmail = urlParams.get("email");
  const userTveCode = urlParams.get("tveCode");
  const userPhoneNumber = urlParams.get("phoneNumber");
  const user = fetchUserObject()
  sessionStorage.removeItem('tveAuthenticated')
  if (!authToken) return;

  if (authToken && !userEmail && !userTveCode) {
    pubsub.publish("apploading", true);
    setAlternateBillingParamsFromUrl(urlParams)
    login.then((m) =>
      m
        .login({ auth: authToken }, undefined, "validate")
        .then(async (response) => {
          let res = response?.identityAuthOtpValidate
          us.then((m) =>
            m.updateAuthorisationStore({ userdetails: res }).then((u) => {
              const planId = urlParams.get("planId");
              const type = urlParams.get("subscriptionType");
              const app = urlParams.get("app");

              const url = new URL(window.location.origin + window.location.pathname)

              if (planId) url.searchParams.set('planId', planId);
              if (app) url.searchParams.set('app', app);
              if (type) url.searchParams.set('type', type);

              if (res.isSubscribed) pubsub.publish("user", { ...res, provider: "EMAIL" });
              else pubsub.publish("user", { isSubscribed: false, provider: "EMAIL" });
              
              const navigateToExternalUrl = isNavigateToExternalUrl();
              if (!navigateToExternalUrl) {
                pubsub.publish("apploading", false);
                pubsub.publish("magic-link", { success: true, message: "Authenticated successfully" })
              }
              if (u) {
                window.location.href = url.toString();
              }
              pubsub.publish("apploading", false);
            })
          );
        }).catch(error => {
          logger(error, "error")
          pubsub.publish("apploading", false);
          pubsub.publish("magic-link", { success: false, message: error.message ?? "Something went wrong" })
        })
    );
  }

  if ((authToken && (userEmail || userPhoneNumber) && userTveCode) || (authToken && (userEmail || userPhoneNumber))) {
    if (user) {
      if ((userEmail == String(user?.email)) || (user?.phoneNumber && userPhoneNumber && user?.phoneNumber.includes(userPhoneNumber.trim()))) {
        sessionStorage.setItem('tveAuthenticated', JSON.stringify({ email: userEmail, phone: userPhoneNumber, tveCode: userTveCode }))
      } else {
        sessionStorage.setItem('tveAuthenticated', JSON.stringify({ isUserValid: false, email: userEmail, phone: userPhoneNumber }))
      }
    } else {
      login.then((m) =>
        m
          .login({ auth: authToken }, undefined, "validate")
          .then(async (response) => {
            let res = response?.identityAuthOtpValidate
            us.then((m) =>
              m.updateAuthorisationStore({ userdetails: res }).then((u) => {
                if (res.isSubscribed) pubsub.publish("user", { ...res, provider: "EMAIL" });
                else pubsub.publish("user", { isSubscribed: false, provider: "EMAIL" });
                pubsub.publish("apploading", false);
                sessionStorage.setItem('tveAuthenticated', JSON.stringify({ email: userEmail, tveCode: userTveCode, phone: userPhoneNumber }))
                pubsub.publish("user", { tveMagicLinkSuccess: true, email: userEmail, tveCode: userTveCode, phone: userPhoneNumber });
                pubsub.publish("magic-link", { success: true, message: "Authenticated successfully" })
              })
            );
          }).catch(error => {
            logger(error, "error")
            pubsub.publish("apploading", false);
            pubsub.publish("magic-link", { success: false, message: error.message ?? "Something went wrong" })
          })
      )
        .catch((err) => {
          console.log("error in loading login module", err)
        })

    }
  }
}


export const fetchPublicKey = () => {
  const publicKey = window?.app_data?.appcmsMain?.publicKey
  const key = axios.get(publicKey)
  return key
}
const fetchCurrentPlan = () => {
  let currentStoredPlan = parseJSON(sessionStorage.getItem('currentPlan'))
  if (currentStoredPlan) return currentStoredPlan
  return false
}
export const handleStatusGaCalls = async ({ type, reason, status, action, paymentStatus, eventCategory, subSection, eventName, section, additionalLabel }) => {
  if (eventName == 'checkout_init') {
    sessionStorage.setItem('checkout-initiate', JSON.stringify(true))
  } else if (eventName == "checkout_cancellation") {
    sessionStorage.setItem('checkout_cancellation', JSON.stringify(false))
    sessionStorage.getItem('checkout-initiate') ? sessionStorage.removeItem('checkout-initiate') : ''
  } else if (eventName == 'checkout_success') {
    sessionStorage.getItem('checkout-initiate') ? sessionStorage.removeItem('checkout-initiate') : ''
    sessionStorage.getItem('checkout_cancellation') ? sessionStorage.removeItem('checkout_cancellation') : ''
    sessionStorage.setItem('checkout_success', JSON.stringify(false))
  } else {
    sessionStorage.setItem('checkout_error', JSON.stringify(false))
  }
  let userLocation = parseJSON(localStorage.getItem('locationCoords'))
  if (userLocation) {
    userLocation['origip'] ? delete userLocation['origip'] : '' //This violates GDPR/Google terms 
  }
  let event_name = eventName
  let userData = fetchUserObject()
  let plan = fetchCurrentPlan()
  let payload = {
    logged_in_status: userData?.userId ? 'Yes' : 'No',
    subscribed_status: userData?.isSubscribed ? 'Yes' : 'No',
    // email : userData?.email, //This violates GDPR/Google terms 
    userId: userData?.userId,
    // mobile : userData?.mobile, // Yes, collecting and sending mobile numbers to Google Analytics 4 (GA4) violates both GDPR and Google's Terms of Service,
    monetizationType: plan?.type,
    currencycode: plan?.currency,
    subscription_plan: plan?.title,
    // user_location : userLocation ? userLocation : null, //This violates GDPR/Google terms 
    event_category: eventCategory,
    event_action: action,
    event_value: plan?.amount || null,
  }
  if (reason) {
    payload[`event_label1`] = reason
  }
  if (status) {
    payload[`event_label2`] = status
  }
  if (section) {
    payload.section = section
  }
  if (subSection) {
    payload.sub_section = subSection
  }
  if (additionalLabel) {
    payload[`event_label3`] = additionalLabel
  }
  if (eventName == 'checkout_init' || eventName == "checkout_cancellation" || eventName == 'checkout_success' || eventName == 'checkout_error') {
    let ecommercePayload = {
      ecommerce: {
        currencycode: plan?.currency,
        value: plan?.amount,
        items: [payload],
      }
    }
    trackEvent(event_name, ecommercePayload, null)
  } else {
    trackEvent(event_name, payload, null)
  }
}
export const getFaqLink = () => {
  const host = window?.location?.origin;
  const footerLinks = window.app_data?.appcmsPlatform?.navigation?.footer
  const faqLinkObj = footerLinks?.filter((element) => element?.title?.toLowerCase()?.includes('faq'))
  const faqLinkUrl = (faqLinkObj && faqLinkObj[0]?.url) || null
  const faqLink = faqLinkUrl?.toLowerCase()?.includes('https://') ? faqLinkUrl : (host + faqLinkUrl)
  return faqLink
}

export const isCheckoutFlow = () => {
  const compliance = window?.app_data?.site?.settings?.compliance;
  let flowUrls = getFlowSteps(compliance)
  if (flowUrls?.includes("/checkout")) {
    return true
  } else {
    return false
  }
}

export const requestZipCode = async () => {
  let baseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;

  const getlocationViaCoords = async (latitude, longitude) => {
    let token = await getToken((token) => { return token });
    return axios.get(`${baseUrl}/geolocation?latitude=${latitude}&longitude=${longitude}`, {
      headers: { Authorization: token }
    });
  }

  const getlocationInfoViaIp = async () => {
    let token = await getToken((token) => { return token });
    return axios.get(`${baseUrl}/geolocation`, {
      headers: { Authorization: token }
    });
  }

  const getPostalCode = (latitude, longitude) => {
    return getlocationViaCoords(latitude, longitude)
      .then(res => res?.data?.postalcode)
      .catch(err => {
        logger(`Error fetching location by coordinates: ${err}`);
        return null;
      });
  };

  const getPostalCodeViaIp = () => {
    return getlocationInfoViaIp()
      .then(res => res?.data?.postalcode)
      .catch(err => {
        logger(`Error fetching location by IP: ${err}`);
        return null;
      });
  };

  return new Promise(async (resolve) => {
    let fallbackTimeout
    fallbackTimeout = setTimeout(async () => {
      const postalCode = await getPostalCodeViaIp();
      resolve(postalCode)
    }, 5000)
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          let coordinates = position.coords;
          if (coordinates?.latitude && coordinates?.longitude) {
            clearTimeout(fallbackTimeout)
            const postalCode = await getPostalCode(coordinates.latitude, coordinates.longitude);
            resolve(postalCode);
          }
        },
        async (error) => {
          switch (error.code) {
            case error.PERMISSION_DENIED:
              logger("User denied the request for Geolocation.", "error");
              clearTimeout(fallbackTimeout)
              const postalCode = await getPostalCodeViaIp();
              resolve(postalCode);
              break;
            case error.POSITION_UNAVAILABLE:
              clearTimeout(fallbackTimeout)
              logger("Location information is unavailable.", "error");
              resolve(null);
              break;
            case error.TIMEOUT:
              clearTimeout(fallbackTimeout)
              logger("The request to get user location timed out.", "error");
              resolve(null);
              break;
            default:
              logger("An unknown error occurred.", "error");
              clearTimeout(fallbackTimeout)
              resolve(null);
              break;
          }
        }
      );
    } else {
      const postalCode = await getPostalCodeViaIp();
      resolve(postalCode);
    }
  });
};

export function capitalize(variable) {
  return variable.replace(/^\w/, c => c.toUpperCase());
}

export const getUnixTimestamp = (date) => {
  if (date) {
    return new Date(date).getTime() / 1000
  } else {
    return null
  }
}

export function getCurrencySymbol(currency) {
  if (!currency) return "$"
  if (currency === "MXN") return currency
  return getSymbolFromCurrency(currency)
}

/**
 * 
 * @param {"MONTH" | "YEAR" | "mo" | "yr" | null | undefined} label 
 * @returns {String} 
 */
export function getLocalizedMonthYearText(label) {
  if (!label) return null
  const generics = window?.app_data?.appcmsMain?.genericMessages
  if (label === "YEAR" || label === "yr") return generics?.yearText ?? label
  if (label === "MONTH" || label === "mo") return generics?.monthText ?? label
  return label
}

export const getCustomMacros = async () => {
  let macros = {}
  let md5 = require('md5')
  const fwTveProvider = await getFwTveProvider()
  const store = await fetchUserDetails();
  const token = await getToken()
  let monetizationModels = []
  let monetizationPlans = []
  let monetisationFrequnecy = ''
  if (store?.user?.isSubscribed) {
    monetizationModels.push('SVOD')
    monetisationFrequnecy = store?.user?.subscription?.subscriptionPlanInfo?.renewalCycleType?.toLowerCase()
    if (store?.user?.isVip) {
      monetizationPlans.push('VIP Plan')
    } else {
      monetizationPlans.push(store?.user?.subscription?.subscriptionInfo?.planId)
    }
  }
  if (store?.user?.tveMetadata?.tveProvider || store?.user?.tveProvider) {
    monetizationModels.push('TVE')
    if (store?.user?.isVip) {
      monetizationPlans.push('VIP Plan')
    } else {
      monetizationPlans.push(store?.user?.tveSubscriptions?.[0]?.planId || store?.user?.subscription?.tveSubscriptions?.[0]?.planId)
    }
  }
  const isMonetizationModels = (monetizationModels && monetizationModels.length > 0) ? true : false
  const isMonetizationPlans = (monetizationPlans && monetizationPlans.length > 0) ? true : false

  const us_priv_cookie_val = Cookies.get("us_privacy") || Cookies.get("usprivacy");
  const US_PRIVACY_VAL = us_priv_cookie_val !== undefined ? us_priv_cookie_val : '1YNN';
  const userCountry = jwtDecode(token)?.countryCode || store?.user?.country
  const userState = store?.user?.city || ''

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isMobileDevice = /android|iphone|ipad|ipod|windows phone/i.test(userAgent.toLowerCase());

  macros = {
      ...(isMonetizationModels && {'VIEWLIFT_MONETIZATION_MODEL': monetizationModels?.toString()}),
      ...(isMonetizationPlans && {'VIEWLIFT_MONETIZATION_PLAN': monetizationPlans?.toString()}),
      VIEWLIFT_US_PRIVACY : US_PRIVACY_VAL,
      'VIEWLIFT_MODEL_FREQUENCY':monetisationFrequnecy,
      'VIEWLIFT_DEVICE_CONECTION':navigator?.connection?.effectiveType,
      'VIEWLIFT_USER_COUNTRY':userCountry,
      'VIEWLIFT_USER_STATE':userState,
      'VIEWLIFT_DEVICE_CATEGORY': isMobileDevice ? 'mobile' : 'desktop',
      'VIEWLIFT_TVE_PROVIDER': fwTveProvider ?  md5(fwTveProvider) : '',
      'VIEWLIFT_ROKU_AD_ID':'',
      'VIEWLIFT_ROKU_AD_KEYS':'',
      'VIEWLIFT_AM_HBT':'',
      'VIEWLIFT_AM_HBMAXT':'',
      'VIEWLIFT_SEAT_ID':'',
      'VIEWLIFT_TAG_ID':'',
    }
  return macros
}

const getMVPDProvider = async () => {
  const store = getStorageItem('AuthenticationStore')
  return store?.user?.tveMetadata?.mvpdProvider || null
}

const getTVEProvider = async () => {
  return window?.app_data?.appcmsPlatform?.tveSettings?.tveProvider || null
}

export const getPlayerBeaconParams = async () => {
  const mvpd_provider = await getMVPDProvider() || null;
  const tve_provider = await getTVEProvider() || null;
  const getKetchVPPAEnabled = isKetchVPPAEnabled()
  return {
    appversion: serverConfig?.buildNumber || null,
    ...((mvpd_provider && tve_provider) && { mvpdprovider: mvpd_provider }),
    ...((tve_provider && mvpd_provider) && { tveprovider: tve_provider }),
    userConsent: getKetchVPPAEnabled
  }
}

export const isTveOnlyLoginEnabled = () => {
  let serviceTypes = handleSeviceTypes()
  // check for tve user loggedin
  const isTveLoginEnabled = window?.app_data.appcmsMain?.monetizationConfig?.tveLoginOnly
  let isTve = serviceTypes?.TVE && isTveLoginEnabled ? true : false
  return isTve
}
/**
 * Function to get the content expiry timestamp and based on that, the delay until page should be reloaded
 * @param {string | null} rentedContentId 
 * @returns {Promise<number>} reload relay
 */
export async function getTimeToRentExpiryInMilliSeconds(rentedContentId) {
  try {
    const token = await getToken();
    const txn = await axios({
      method: 'GET',
      url: `${apiBaseUrl}/v3/transaction`,
      headers: {
        Authorization: token,
      },
    });
    if (txn.status !== 200 || !txn.data?.records || !Array.isArray(txn.data?.records)) return null;
    // find rentedContent in txn list
    const content = txn.data?.records?.find(
      (item) => item?.contentId === rentedContentId && item?.purchaseType === 'RENT'
    );
    if (!content) return null;
    const now = new Date().getTime();
    const rentEndTime = new Date(content.transactionEndDate).getTime();
    if (now > rentEndTime) {
      await updateUserTransactionList(rentedContentId);
      return 0;
    }
    return rentEndTime - now; // this will be used as the delay for setTimeout
  } catch (err) {
    console.error(err);
  }
}

export async function updateUserTransactionList(contentId) {
  try {
    let transactionUserList = getStorageItem('transactionUserList');
    if (!transactionUserList?.transactionUserList || !Array.isArray(transactionUserList?.transactionUserList)) return;
    const _updated = transactionUserList?.transactionUserList?.filter((item) => item !== contentId);
    setStorageItem('transactionUserList', { transactionUserList: _updated });
  } catch (err) {
    console.error(err);
  }
}

export const fomulateCategories = (primary, rest) => {
  let categories = []
  if (primary?.title) categories.push(primary?.title)
  if (rest?.length) {
    let restCategories = rest?.map((rating) => rating?.title ? rating?.title : "")
    categories.push(...restCategories)
  }
  return categories.join(", ")
}
/**
 * Function to check whether Ketch VPPA is enabled or not.
 */
export const isKetchVPPAEnabled = () => {
  const isKetchEnabled = (window?.app_data?.appcmsPlatform?.privacy?.ketchCookie?.enable) || false
  if (isKetchEnabled) {
    const ketchConsent = localStorage.getItem('_ketch_consent_v1_') ? parseJSON(atob(localStorage.getItem('_ketch_consent_v1_'))) : ''
    const vppaStatus = (ketchConsent?.vppa?.status) || ''
    if (vppaStatus === 'granted') {
      return true
    } else {
      return false
    }
  } else {
    return true //Ketch is not enabled, but it is passing the check
  }
}

export const watchHistoryEnabled = () => {
  const isWatchHistoryEnable = (window?.app_data?.appcmsMain?.features?.watched_history?.enable) || false;
  return (isWatchHistoryEnable ? isKetchVPPAEnabled() : false)
}
/* The function `checkAndReplaceContent` checks if a given text contains a specific search string, and
* if it does, replaces it with another string.
* @param text - The `text` parameter is the original text or string where you want to search for a
* specific `search` string and replace it with another `replace` string if found.
* @param search - The `search` parameter is the text or substring that you want to find within the
* `text` parameter.
* @param replace - The `replace` parameter in the `checkAndReplaceContent` function is the string that
* will replace the `search` string in the `text` if the `search` string is found within the `text`.
* @returns The function `checkAndReplaceContent` returns the original `text` if the `search` string is
* not found within it. If the `search` string is found within the `text`, it returns the `text` with
* the `search` string replaced by the `replace` string.
*/
export function checkAndReplaceContent(text, search, replace) {
  if (text.includes(search)) return text.replace(search, replace);
  return text;
}

export const trackRefModule = (type, moduleName) => {
  // used by adobe analytics to keep a track of the tray or navigation section which the user previously clicked on
  if (type === "set") {
    sessionStorage.setItem("ref-module", moduleName)
  } else {
    return sessionStorage.getItem("ref-module")
  }
}

export function setPageTree(type, contextData, networks = ['cnbc', 'e', 'msnbc', 'oxygen-true-crime', 'oxygen', 'peacock', 'syfy', 'usa-network', 'golfchannel','msnow']) {
  const pathname = window.location.pathname || '/';

  if (pathname === '/') {
    window.pageTree = 'global:home';
    return;
  }

  if (type === 'series') {
    const base = `global:shows:${contextData?.seriesTitle}`;
    window.pageTree = contextData?.epsTitle
      ? `${base}:${contextData.seasonNumber}:${contextData.epsNumber}`
      : base
    return;
  }

  if(type === "sle") {
    let sleType = contextData?.isActiveStream ? 'live' : 'fer'
    window.pageTree = `global:${sleType}:${contextData?.title}`;
    return
  }

  if (type === 'vod') {
    window.pageTree = `global:movies:${contextData?.title}`;
    return;
  }
  const segments = pathname.replace(/^\/|\/$/g, '').split('/');
  const isNetwork = segments.length === 1 && networks.includes(segments[0].toLowerCase());
  const isShowsPage = segments.length === 2 && (segments[0].toLowerCase() === 'shows' || segments[0].toLowerCase() === 'browse') && networks.includes(segments[1].toLowerCase());
  const userPage =  window?.page_data?.page?.pageType === "UserPage"
  const treeParts = ['global'];
  if (isNetwork) {
    treeParts.push('network');
  }
  if (userPage && !segments.includes('account')) {
    treeParts.push('account');
  }
  
  if(segments[0].toLowerCase() === 'shows' || segments[0].toLowerCase() === 'browse') {
    segments[0] = 'shows'
  }
  treeParts.push(...segments);
  // order matters
  if(isShowsPage) {
    treeParts.splice(2,0,'all');
  }
  if(type === 'search-results') {
    treeParts.push('search-results');
  }

  window.pageTree = treeParts.join(':');
}
export const getPlayerDebugConfig = () => {

  if (typeof window === "undefined") return { playerDebug: false, logLevel: 'info' };

  const debugLevels = ['none', 'fatal', 'error', 'warning', 'info', 'debug'];

  const location = window?.location?.search || "";
  const urlParams = new URLSearchParams(location);
  const playerDebug = urlParams.get('debug');
  const logLevel = urlParams.get('loglevel');

  const isDebugEnabled = playerDebug === 'true' ? true : false;
  const isLogLevelValid = logLevel && debugLevels.includes(logLevel);

  return {
    enable: isDebugEnabled,
    logLevel: isLogLevelValid ? logLevel : 'debug', // Default to 'info' if not valid
  };
}

export const structuredPlan = (plan) => {
  let planDetails = plan?.planDetails?.length ? plan.planDetails[0] : {}

  const tvodType = getTvodType()

  let planType;

  if (plan?.monetizationModel === "SVOD") {
    planType = "Svod";
  } else if (plan?.monetizationModel === "TVE" || plan?.type === "TVE") {
    planType = "TVE";
  } else if (plan?.type === "FreeAccount") {
    planType = "FreeAccount";
  } else if ((tvodType === "rent") && (planDetails?.isRentEnabled)) {
    planType = "Rent";
  } else {
    planType = "Buy";
  }


  return {
    title: plan?.name || planDetails?.title,
    subTitle: plan?.description || planDetails?.description || "",
    amount: planDetails?.recurringPaymentAmount || planDetails?.purchaseAmount,
    currency: planDetails?.recurringPaymentCurrencyCode,
    cycleType: plan?.renewalCycleType ? plan?.renewalCycleType === "MONTH" ? "mo" : "yr" : null,
    features: '',
    plansDetail: planDetails,
    planId: plan?.monetizationModel === "TVE" ? "TVE" : plan?.id,
    identifier: plan?.identifier,
    type: planType,
    description: plan?.description
  }
}

export const getPlanByPlanId = async (ids) => {
  let site = window?.app_data?.site?.siteInternalName;
  let { userId } = await fetchUserDetails()
  if (userId) {
    let token = await getToken(token => { return token })
    let params = {
      site: site,
      userId: userId,
      ids: ids,
      device: 'web_browser',
      visible: true
    }
    let res = await axios({
      method: 'GET',
      url: `${apiBaseUrl}/v3/plans`,
      params,
      headers: {
        Authorization: token,
        'x-api-key': window?.xApiKey
      }
    })
    return res?.data
  }
};

const setAlternateBillingParamsFromUrl = (urlParams) => {
  if (!urlParams) return;

  const platform = urlParams.get('platform');
  const ett = urlParams.get('ett');
  const planId = urlParams.get('planId');
  const redirectUrl = urlParams.get('redirectUrl');
  const externalTvodType = urlParams.get('tvodType');
  const externalContentId = urlParams.get('contentId');
  const externalContentType = urlParams.get('contentType');
  const externalSubscriptionType = urlParams.get('subscriptionType');
  const app = urlParams.get('app');

  const alternateBillingParams = {};

  if (app) alternateBillingParams.app = app;
  if (planId) alternateBillingParams.planId = planId;
  if (ett) alternateBillingParams.externalTransactionToken = ett;
  if (platform) alternateBillingParams.externalPlatform = platform;
  if (redirectUrl) alternateBillingParams.externalRedirectUrl = redirectUrl;
  if (externalTvodType) alternateBillingParams.externalTvodType = externalTvodType;
  if (externalContentId) alternateBillingParams.externalContentId = externalContentId;
  if (externalContentType) alternateBillingParams.externalContentType = externalContentType;
  if (externalSubscriptionType) alternateBillingParams.externalSubscriptionType = externalSubscriptionType;
  
  // Store only if at least one param exists
  if (Object.keys(alternateBillingParams).length > 0) {
    sessionStorage.setItem('alternateBillingParams', JSON.stringify(alternateBillingParams));
  }
}

export const getAlternateBillingParams = () => {
  const params = sessionStorage.getItem('alternateBillingParams');
  return params ? JSON.parse(params) : null;
}

/** For Cancel Subscription, Renew Subscription, Manage Payment, Upgrade Subscription */
export const getExternalSubscriptionType = () => {
  let queryString = window.location.search;
  let urlParams = new URLSearchParams(queryString);
  const type = urlParams.get("type");
  return type ? type : null;
}

export const removeAlternateBillingParams = () => {
  sessionStorage.getItem('alternateBillingParams') && sessionStorage.removeItem('alternateBillingParams')
}

/* We are trying to open an Android/IOS app(Deep link), do NOT use navigate. */
// export const isNavigateToExternalUrl = () => {
//   const { externalPlatform, externalRedirectUrl } = getAlternateBillingParams() || {};
//   if (externalPlatform && externalRedirectUrl) {
//     return externalRedirectUrl;
//   } else {
//     return false;
//   }
// }
export const isNavigateToExternalUrl = () => {
  const { externalPlatform, externalRedirectUrl } = getAlternateBillingParams() || {};

  if (externalPlatform && externalRedirectUrl) {
    // localStorage.clear();
    let redirectUrl;
    if(isExternalPlatformIos()) {
      // redirectUrl=dirtvision://test-stripe-success
      redirectUrl = `${window?.app_data?.site?.siteInternalName}://${externalRedirectUrl}`;
    } else {
      redirectUrl = externalRedirectUrl;
    }
    return redirectUrl;
  } else {
    return false;
  }
}
const isExternalPlatform = (platform) => {
  const { externalPlatform, externalRedirectUrl } = getAlternateBillingParams() || {};
  return externalPlatform === platform && !!externalRedirectUrl;
}
/** For Android Platform */
export const isExternalPlatformAndroid = () => {
  return isExternalPlatform('android_phone');
}
/** For iOS Platform */
export const isExternalPlatformIos = () => {
  return isExternalPlatform('ios_phone');
}
/** TVOD Type can be "rent" or "buy" */
export const getTvodType = () => {
  const allowedTypes = ["rent", "buy"];

  let queryString = window.location.search;
  let urlParams = new URLSearchParams(queryString);
  const tvodType = urlParams?.get("tvodType")

  const { externalTvodType } = getAlternateBillingParams() || {};
  
  const finalTvodType = (externalTvodType || tvodType || "").toLowerCase()

  return allowedTypes.includes(finalTvodType) ? finalTvodType : null;
}
export const isExternalUrl = () => {
  let queryString = window.location.search;
  let urlParams = new URLSearchParams(queryString);
  const platform = urlParams.get("platform");
  const redirectUrl = urlParams.get("redirectUrl");
  return (platform && redirectUrl) ? true : false;
}